import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[wrGroupHeader]',
})
export class GroupedListViewHeaderDirective<T = any> {
  constructor(
    public readonly templateRef: TemplateRef<T>,
  ) {
  }
}
